import UIManager from "../Shared/UIManager";
import AudioManager from "../Shared/AudioManager";

const { ccclass, property } = cc._decorator;

@ccclass
export class ConfirmBox extends cc.Component {

    @property(cc.Label)
    labelContent: cc.Label = undefined;
    @property(cc.Button)
    btnOk: cc.Button = undefined;
    @property(cc.Button)
    btnCancel: cc.Button = undefined;
    @property(cc.Label)
    labelOk:cc.Label = undefined;
    @property(cc.Label)
    labelCancel:cc.Label = undefined;
    private _okCallback: () => void = undefined;
    private _cancelCallback: () => void = undefined;

    private _btnX: number = 0;

    init() {
        this._btnX = this.btnOk.node.x;
    }
    onLoad() {
    }

    showConfirm(content: string, okCallback?: () => void, textYes ?: string,cancelCallback?: () => void, textNo ?: string) {
        textYes && (this.labelOk.string = textYes);
        textNo && (this.labelCancel.string = textNo);
        this.btnOk.node.active = true;
        this.btnCancel.node.active = true;
        this._okCallback = okCallback;
        this._cancelCallback = cancelCallback;
        this.labelContent.string = content || "";    // 防止 undefined 时报错
        this.node.active = true;
    }
    showTip(content: string, cb ? : ()=>void, textYes ? : string){
        textYes && (this.labelOk.string = textYes);
        this._okCallback = cb;
        this.btnCancel.node.active = false;
        this.btnOk.node.active = true;
        this.labelContent.string = content || "";    // 防止 undefined 时报错
        this.node.active = true;
    }
    onClicked(event: cc.Event, param: string) {
        AudioManager.playSound("button");
        switch (param) {
            case 'ok':
                if (typeof this._okCallback === "function") {
                    this._okCallback();
                }
                break;
            case 'cancel':
                if (typeof this._cancelCallback === "function") {
                    this._cancelCallback();
                }
                break;
        }
        this._okCallback = undefined;
        this._cancelCallback = undefined;
        // 关闭界面
        this.node.destroy();
        UIManager.confirmBox = null;
        UIManager.boxNum = 0;
    }
}
